export default __webpack_public_path__ + "static/may-you-propser-3a6bc8397e78a2c9f9efe0b6f0223c4e.svg";